import { numberToPrettyString } from '@cian/utils';
import { TOfferCategory } from '../../../../types/offer';
import { getPaymentPeriod } from './getPaymentPeriod';

export interface IGetRentPriceParams {
  priceRur: number;
  category: TOfferCategory | null;
}

export function getRentPrice({ priceRur, category }: IGetRentPriceParams): string {
  return `${numberToPrettyString(priceRur)} ₽/${getPaymentPeriod(category)}`;
}
